/* eslint-disable */
/* eslint-disable object-curly-newline */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { connect } from 'react-redux';
import Chip from '@mui/material/Chip';
// import DownloadIcon from '@mui/icons-material/Download';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import moment from 'moment';
import DatePicker from 'rsuite/DatePicker';
import { EditIcon, Filter, RefreshCcw, Trash2 } from 'lucide-react';
import {
	analyticsAction,
	formActions,
	modalActions,
} from '../../../../Actions';
import { ListTable } from '../../../../Components/ListTable';
import { POItemsModal } from '../../../../Components/Modals/POItemsModal';
import styles from './PurchaseOrderList.module.scss';
// import PurchaseOrderListHeader from './PurchaseOrderListHeader/PurchaseOrderListHeader';
import { VanImageModal } from '../../../../Components/Modals/VanImageModal';
import assetServices from '../../../../Services/AssetServices/asset.services';
import { notificationServices } from '../../../../Services';
import inventoryAnalyticsServices from '../../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal, ProductionPlanModal } from '../../../../Components/Modals';
import BackdropLoader from '../../../../Components/Loaders/BackdropLoader';
import { urls } from '../../../../Constants';
import {
	addCommas,
	classes,
	filtersInfoChip,
	handleImagePreview,
	handleOrderStatus,
	handleResponseStreamDownload,
	multiplePoCustomers,
	useQuery,
	useSearch,
} from '../../../../Helpers';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import ExportFiltersDrawer from '@/Components/Drawers/ExportFiltersDrawer/ExportFiltersDrawer';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';
import drawerActions from '@/Actions/drawer.actions';
import DebitCreditListDrawer from '@/Components/Drawers/DebitCreditListDrawer/DebitCreditListDrawer';
import { Button } from '@/Components/ui/button';
import DatePickerModal from './DatePickerModal';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import AssetTransitModal from '@/Components/Modals/AssetTransitModal/AssetTransitModal';
import SearchBar from '@/Components/SearchBar/SearchBar';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalSearch from '@/Components/globalSearch/search';
import { Tooltip } from '@mui/material';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from '@mui/material';
import { getStorageKey } from '../../CreatePurchaseOrder/CreatePurchaseOrder.config';
import { loadState } from '@/Helpers/persistenceUtils';
import { SelectPicker } from 'rsuite';
import { useDispatch } from 'react-redux';
import MultiPoModal from '@/Components/Modals/MultiPoModal/multiPoModal';

const exportTypes = [
	{
		label: 'Invoice-Item wise Sales Register',
		value: 'invoiceItemWiseSales',
	},
	{
		label: 'Item-Wise GRN Fullfilment',
		value: 'itemWiseGrn',
	},
	{
		label: 'Item-Wise Sales Register',
		value: 'itemWiseSales',
	},
];

const TABLE_COLUMNS = [
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client PO ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Invoice Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Dispatch Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Received Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Receive date',
		config: {
			type: 'DATA',
		},
	},

	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Generation Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Van Temp',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vehicle No',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vehicle Image at Dispatch',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vehicle Image at Receiving',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Temp Meter Image',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Amount',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'Download',
		config: {
			type: 'VIEW',
		},
	},
	// {
	// title: 'View',
	// config: {
	// type: 'VIEW',
	// },
	// },
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Action',
		config: {
			type: 'CANCEL',
		},
	},
	// {
	// title: 'MORE',
	// config: {
	// type: 'MORE',
	// },
	// },
];

const COLMAP = {
	'PO Id': 'id',
	'Client PO ID': 'clientPoId',
	'Order Date': 'createdAt',
	'Invoice Date': 'invoicedAt',
	'Received Date': 'receivedAt',
	'Expected Dispatch Date': 'id',
	'Expected Receive date': 'id',
	'Deliver To': 'storeName',
	BASE: 'fromStoreName',
	'Van Temp': 'receivingTemp',
	'Temp Meter Image': 'receivingTempImage',
	// 'Transit Van Temp': 'receivingTemp',
	'Order Status': 'orderStatus',
	'Generation Type': 'id',
	Vendor: 'vendorName',
	Buyer: 'vendorName',
	'Vehicle No': 'orderImages',
	'Vehicle Image at Dispatch': 'orderImages',
	'Vehicle Image at Receiving': 'orderImages',
	'Created By': 'initiatedByName',
};

const orderStatus = [
	'PENDING',
	'DISPATCH',
	'TRANSIT',
	'UNLOADING',
	'VERIFICATION',
	'FULFILLED',
	'CANCELLED',
	'ABANDONED',
];

const SEARCH_BY = {
	options: [
		{
			key: 'clientPoId',
			title: 'Client Po Id',
		},
	],
};

const dateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Expected Dispatch Date',
		value: 'dispatchDate',
	},
	{
		label: 'Expected receive date',
		value: 'scheduled',
	},
	{
		label: 'Invoice Date',
		value: 'invoiced',
	},
	{
		label: 'Received Date',
		value: 'received',
	},
];

function PurchaseOrderList(props) {
	const {
		data,
		type,
		toggleModal,
		toggleVanImageModal,
		toggleAlert,
		// toggleFileUploaderModal,
		toggleProductionPlanModal,
		navState,
		stores,
		fetchPurchaseOrderList,
		categoriesList,
		subCategoriesList,
		fetchSubCategories,
		toggleExportFiltersDrawer,
		toggleDebitCreditListDrawer,
		userList,
		fetchUserList,
		toggleAssetTransit,
		toggleFiltersDrawer,
		alertModalState,
		toggleMultiplePoModal,
	} = props;
	const query = useQuery();
	const poId = query?.get('poId');
	const isInternalSales = type === 'internalSales';
	const [update, setUpdate] = useState(-1);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const navRequisites = navState?.[urls.SALES_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [datePickerModalState, setDatePickerModalState] = useState({
		show: false,
		heading: '',
		currentPo: null,
	});
	const [productionPlanLoading, setProductionPlanLoading] = useState(false);
	const exportFilters = useRef({});
	const [search, setSearch] = useState({});
	const [filterValue, setFilterValue] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict = {} } = userConfig || {};
	const isBakingoCustomer = appConfig?.customerId === 52;
	const isWynBrands = appConfig?.customerId === 67;
	const isA2bCustomer = !multiplePoCustomers.includes(appConfig?.customerId);
	const isInternal =
		Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') ||
		Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const procurmentRole = Object?.values?.(userRolesDict ?? {}).includes(
		'Procurement'
	);
	const [shift, setShift] = useState('');
	const dispatch = useDispatch();
	const [selectedRow, setSelectedRow] = useState([]);
	const handleDatePickerModalSetDate = useCallback(async (date, item) => {
		if (
			moment(item?.scheduledAt, 'YYYY-MM-DD HH:mm:ss').format(
				'YYYY-MM-DD'
			) === moment(date).format('YYYY-MM-DD')
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Date is already same',
			});
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Updating Date',
		});
		try {
			const response = await inventoryAnalyticsServices?.editVendorPO({
				params: {
					poId: item?.id,
				},
				data: {
					scheduled: moment(date).format('MM/DD/YYYY'),
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
				setFilters((prev) => {
					return {
						...prev,
						blink: !prev?.blink,
					};
				});
				setTimeout(() => {
					notificationServices.generateNotification({
						type: 'wave',
						message: 'Press find again to get latest updates',
						config: {
							id: notificationId,
						},
					});
				}, 1500);
				setDatePickerModalState({
					show: false,
					heading: '',
					currentPo: null,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				},
			});
		}
	}, []);

	const handleDatePickerModalOpen = useCallback((item) => {
		setDatePickerModalState({
			show: true,
			heading: `Expected Receive date for ${item?.clientPoId}`,
			currentPo: item,
		});
	}, []);

	useEffect(() => {
		exportFilters.current = {
			...exportFilters.current,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,
		};
	}, [navSelectedStore?.value?.id]);

	const [filters, setFilters] = useState({
		storeId: null,
		dateRange: {
			startDate: new Date(),
			endDate: new Date(),
		},
	});

	const storeIdMap = useMemo(() => {
		const map = {};
		stores?.forEach((store) => {
			map[store?.id] = store;
		});
		return map;
	}, [stores]);

	const shifts = useMemo(() => {
		const seen = new Set();
		return data
			?.map((item) => ({
				label: item?.shiftName,
				value: item?.shiftId,
			}))
			?.filter((item) => {
				if (!item.value || seen.has(item.value)) return false;
				seen.add(item.value);
				return true;
			});
	}, [data]);

	useEffect(() => {
		if (navSelectedStore?.value?.id) {
			setFilters((prev) => {
				return {
					...prev,
					fulfilledBy:
						navSelectedStore?.value?.id === -999
							? null
							: navSelectedStore?.value?.id,
				};
			});
			// setUpdate((prev) => {
			// 	return prev + 1;
			// });
		}
	}, [navSelectedStore?.value?.id, type]);

	const handlePoStatus = (id, status) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Po ${id || ''}`,
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status,
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	// const handleDownloadGRN = (downloadLink) => {
	// window.open(downloadLink);
	// };

	const handleViewClick = (item) => {
		toggleModal(true, {
			heading: `PO Items of #${item?.id}`,
			...item,
			showPdf: item?.poURL,
			showTotal: true,
			showPoDetails: true,
			width: '80%',
			height: '90%',
			transactionData: {
				'Order ID': item?.clientPoId,

				'Deliver To Store': item?.storeName,
				'Deliver From Store': item?.fromStoreName,
				'Deliver To Store GSTIN': item?.storeGstin,
				'Deliver From Store GSTIN': item?.fromStoreGstin,
				'Payment Term': item?.jsonData?.paymentTerm,
			},
			excludedColumns: isInternalSales
				? [
					'PO Id',
					'From Process',
					'Quantity',
					'Returned Quantity',
					'Fulfilled',
					'Returned',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
				]
				: [
					'Packaged',
					'Dispatched',
					'Returned Quantity',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
				],
		});
	};
	const viewMoreOptionsList = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		'View Debit/Credit Note': (item, cb) => {
			toggleDebitCreditListDrawer(true, {
				poId: item?.id,
				heading: `Debit/Credit Notes of ${item?.clientPoId ?? item?.id
					}`,
			});
			cb();
		},
		'View Assets': async (item, cb) => {
			try {
				const res = await assetServices?.fetchAssetTransitFlow({
					req: {
						params: {
							id: Number(item?.id),
						},
					},
				});
				if (res?.statusCode === 200) {
					const response = res?.data;
					if (response.length > 0) {
						toggleAssetTransit(true, {
							heading: `PoId : ${item?.id}`,
							data: response,
						});
					} else {
						notificationServices?.generateNotification({
							type: 'warning',
							message: 'No assets are packaged yet in this PO',
						});
					}
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
				});
			}
		},
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [
			'Id',
			'Client PO Id',
			'Expected Receive date',
			'Order status',
			'Raised by',
			'Fulfilled by',
		];
		const downloadBtn = document.createElement('a');

		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const exportItemsWiseData = () => {
		const headers = [
			'Product Name',
			'Variant',
			'Unit',
			'Product Category',
			'Ordered Quantity',
			'Packaged',
			'Dispatched',
			'Received',
		];
		const totalValues = [];
		data?.forEach((ele) => {
			ele?.items?.forEach((item) => {
				totalValues?.push([
					ele?.id,
					ele?.clientPoId,
					ele?.scheduledAt,
					ele?.orderStatus,
					ele?.storeName,
					ele?.fromStoreName,
					item?.productName?.replaceAll(',', "'"),
					item?.variantName,
					item?.unit,
					item?.categoryName,
					item?.qty,
					item?.packaged,
					item?.fulfilled,
					item?.storeFulfilled,
				]);
			});
		});
		handleExcelDownload(
			headers,
			totalValues,
			`PO_${filters?.dateRange?.startDate}-${filters?.dateRange?.endDate}`
		);
	};

	const isLatLongSameForPOStore = (item) => {
		const fromStoreLatitude = storeIdMap[item?.fromStore]?.latitude;
		const fromStoreLongitude = storeIdMap[item?.fromStore]?.longitude;

		const toStoreLatitude = storeIdMap[item?.storeId]?.latitude;
		const toStoreLongitude = storeIdMap[item?.storeId]?.longitude;

		return (
			fromStoreLatitude === toStoreLatitude &&
			fromStoreLongitude === toStoreLongitude
		);
	};

	const renderDownloadField = (item) => {
		const sendStoreGstin = item?.fromStoreGstin;
		const receiveStoreGstin = item?.storeGstin;

		return (
			<div
				style={{
					width: '125px',
				}}
				className={styles?.downloadDiv}
			>
				{item?.poURL && (
					<Chip
						size='small'
						label='Order'
						onClick={(e) => {
							e.stopPropagation();
							if (item?.poURL) {
								window.open(item?.poURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.deliveryChallanURL && (
					<Chip
						size='small'
						label='DC'
						onClick={(e) => {
							e.stopPropagation();
							if (item?.deliveryChallanURL) {
								window.open(item?.deliveryChallanURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.woDocUrl && (
					<Chip
						size='small'
						label='WO'
						onClick={(e) => {
							e.stopPropagation();
							if (item?.woDocUrl) {
								window.open(item?.woDocUrl);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.invoiceURL &&
					(item?.jsonData?.ewayBill?.url || !isBakingoCustomer) && (
						<Chip
							size='small'
							label='Invoice'
							onClick={(e) => {
								e.stopPropagation();
								if (item?.invoiceURL) {
									window.open(item?.invoiceURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
				{item?.grnURL && (
					<>
						<Chip
							size='small'
							label='GRN'
							onClick={(e) => {
								e.stopPropagation();
								if (item?.grnURL) {
									window.open(item?.grnURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					</>
				)}
				{item?.jsonData?.ewayBill?.url ? (
					<>
						<div
							style={{
								display: 'flex',
								position: 'relative',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<Chip
								size='small'
								label='Eway Bill'
								onClick={(e) => {
									e.stopPropagation();
									if (item?.jsonData?.ewayBill?.url) {
										const anchor =
											document.createElement('a');
										anchor.href = `https://${item?.jsonData?.ewayBill?.url}`;
										anchor.download = 'EwayBill.pdf';
										anchor.target = 'blank';
										anchor.click();
									}
								}}
								icon={<PictureAsPdfIcon />}
							/>
							{level !== 1 && (
								<EditIcon
									style={{
										position: 'absolute',
										right: '0px',
										cursor: 'pointer',
										backgroundColor: '#f0f0f0',
										color: '#666666',
										padding: '1px',
										borderRadius: '4px',
									}}
									size={16}
									onClick={(e) => {
										e.stopPropagation();
										const urlType = 'EWAYBILL';
										const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
										history.push(url);
									}}
								/>
							)}
						</div>
					</>
				) : (
					level !== 1 &&
					item?.orderStatus === 'TRANSIT' &&
					!isLatLongSameForPOStore(item) && (
						<span
							style={{
								cursor: 'pointer',
								color: '#1976d2',
								textDecoration: 'underline',
								fontSize: '12px',
								display: 'inline-block',
								marginLeft: '8px',
								whiteSpace: 'nowrap',
							}}
							onClick={(e) => {
								e.stopPropagation();
								const urlType = 'EWAYBILL';
								const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
								history.push(url);
							}}
						>
							Create E-way Bill
						</span>
					)
				)}
				{sendStoreGstin &&
					receiveStoreGstin &&
					(sendStoreGstin !== receiveStoreGstin ||
						item?.jsonData?.eInvoice?.eInvoiceUrl?.length > 0) &&
					(item?.jsonData?.eInvoice?.eInvoiceUrl ? (
						<>
							{item?.jsonData?.ewayBill?.url ||
								!isLatLongSameForPOStore(item) ? (
								<div
									style={{
										display: 'flex',
										position: 'relative',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									<Chip
										size='small'
										label='E-Invoice'
										onClick={(e) => {
											e.stopPropagation();
											if (
												item?.jsonData?.eInvoice
													?.eInvoiceUrl
											) {
												const anchor =
													document.createElement('a');
												anchor.href =
													item?.jsonData?.eInvoice?.eInvoiceUrl;
												anchor.download =
													'E-Invoice.pdf';
												anchor.target = 'blank';
												anchor.click();
											}
										}}
										icon={<PictureAsPdfIcon />}
									/>
									{level !== 1 && (
										<EditIcon
											style={{
												position: 'absolute',
												right: '0px',
												cursor: 'pointer',
												backgroundColor: '#f0f0f0',
												color: '#666666',
												padding: '1px',
												borderRadius: '4px',
											}}
											size={16}
											onClick={(e) => {
												e.stopPropagation();
												const urlType = 'INVOICE';
												const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
												history.push(url);
											}}
										/>
									)}
								</div>
							) : (
								<span
									style={{
										color: '#a00',
										fontSize: '10px',
										textAlign: 'center',
										display: 'inline-block',
										// marginLeft: '8px',
										width: '100%',
									}}
								>
									*Generate E-way Bill to download Invoices
								</span>
							)}
						</>
					) : (
						level !== 1 &&
						![
							'PENDING',
							'DISPATCH',
							'CANCELLED',
							'ABANDONED',
						].includes(item?.orderStatus) && (
							<span
								style={{
									cursor: 'pointer',
									color: '#1976d2',
									textDecoration: 'underline',
									fontSize: '12px',
									display: 'inline-block',
									marginLeft: '8px',
									whiteSpace: 'nowrap',
								}}
								onClick={(e) => {
									e.stopPropagation();
									const urlType = 'INVOICE';
									const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
									history.push(url);
								}}
							>
								Create E-Invoice
							</span>
						)
					))}
			</div>
		);
	};

	const getPODeltas = (po) => {
		if (po?.orderStatus !== 'CLOSED') return <></>;

		const shortSupplyItems = po?.items
			?.filter(
				(item) => (item?.fulfilled ?? 0) > (item?.storeFulfilled ?? 0)
			)
			?.reduce((acc, item) => {
				const qty =
					(item?.fulfilled ?? 0) - (item?.storeFulfilled ?? 0);
				return (
					acc +
					qty * item?.productCost * (1 + item.taxPercentage / 100)
				);
			}, 0);
		const extraSupplyItems = po?.items
			?.filter(
				(item) => (item?.fulfilled ?? 0) < (item?.storeFulfilled ?? 0)
			)
			?.reduce((acc, item) => {
				const qty =
					(item?.storeFulfilled ?? 0) - (item?.fulfilled ?? 0);
				return (
					acc +
					qty * item?.productCost * (1 + item.taxPercentage / 100)
				);
			}, 0);

		return (
			<div>
				{shortSupplyItems > 0 && (
					<div className='text-red-700 text-[10px]'>
						Loss in transit ₹
						{shortSupplyItems >= 0
							? addCommas(shortSupplyItems)
							: '-'}
					</div>
				)}
				{extraSupplyItems > 0 && (
					<div className='text-red-800 text-[10px]'>
						Extra supply ₹
						{extraSupplyItems >= 0
							? addCommas(extraSupplyItems)
							: '-'}
					</div>
				)}
			</div>
		);
	};

	const SPECIAL_ITEMS = {
		Download: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return renderDownloadField(item);
		},
		'Client PO ID': (value, item) => {
			return (
				<div className='flex items-center gap-2 w-full justify-between'>
					<span className='text-gray-700'>{value}</span>
					<div className='flex items-center gap-2 bg-red-600 px-1 rounded'>
						{item?.jsonData?.priority && (
							<span className='text-xs font-bold text-white'>
								Priority
								<br />
								{item?.jsonData?.parentDisplayPoId ? (
									`(${item?.jsonData?.parentDisplayPoId})`
								) : (
									''
								)}
							</span>
						)}
					</div>
				</div>
			);
		},
		'Expected Dispatch Date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const date = moment(item?.dispatchBy).format('YYYY-MM-DD');
			return <p className=' w-36'>{date}</p>;
		},
		'Expected Receive date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const status = [
				'CANCELLED',
				'CLOSED',
				'ABANDONED',
				'UNLOADING',
				'VERIFICATION',
			];
			if (
				levels.includes(level) &&
				(isInternal || procurmentRole) &&
				!status.includes(item?.orderStatus)
			) {
				return (
					<div
						className='flex w-36 items-center justify-between border border-gray-200 p-2 cursor-pointer hover:bg-gray-50 rounded-md transition-colors'
						onClick={(e) => {
							e.stopPropagation();
							handleDatePickerModalOpen(item);
						}}
					>
						<span className='text-gray-700'>
							{item?.scheduledAt?.split(' ')[0] ?? '-'}
						</span>
						<EditIcon className='text-gray-500 hover:text-gray-700' />
					</div>
				);
			} else {
				return (
					<span className='text-gray-700 block w-[7rem]'>
						{item?.scheduledAt?.split(' ')[0] ?? '-'}
					</span>
				);
			}
		},
		'Generation Type': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const generationType = item?.jsonData?.deltaType;
			if (!generationType)
				return <span className='text-gray-700'>Regular</span>;
			if (generationType === 'UNDER_RECEIVING')
				return (
					<div className='text-red-700 text-[12px]'>
						Under Reciving
					</div>
				);
			if (generationType === 'EXCESS_RECEIVING')
				return (
					<div className='text-red-700 text-[12px]'>
						Excess Reciving
					</div>
				);
		},
		'Deliver From': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div
					style={{
						width: '200px',
						textAlign: 'left',
					}}
				>
					{item?.fromStoreName ?? '-'}
				</div>
			);
		},
		'Order Type': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div
					style={{
						width: '200px',
						textAlign: 'left',
					}}
				>
					{item?.subType ?? '-'}
				</div>
			);
		},
		'Vehicle No': (itemId, data) => {
			return data?.PRE_DISPATCH?.[0]?.vehicleNumber;
		},
		'Vehicle Image at Dispatch': (itemId, data) => {
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl ? (
						<img
							onClick={() =>
								handleImagePreview(
									data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl
								)
							}
							width={100}
							height={50}
							src={data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl}
						/>
					) : (
						<>-</>
					)}
				</div>
			);
		},
		'Vehicle Image at Receiving': (itemId, data) => {
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{data?.VERIFICATION_START?.[0]?.imageUrl ? (
						<img
							onClick={() =>
								handleImagePreview(
									data?.VERIFICATION_START?.[0]?.imageUrl
								)
							}
							width={100}
							height={50}
							src={data?.VERIFICATION_START?.[0]?.imageUrl}
						/>
					) : (
						<>-</>
					)}
				</div>
			);
		},
		'Van Temp': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return item?.receivingTemp ?? '-';
		},
		'Temp Meter Image': (id, src) => {
			const item = data?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{item?.receivingTempImage ? (
						<img
							onClick={(e) => {
								toggleVanImageModal(true, {
									heading: `${item?.id ?? '-'} at ${item?.scheduledAt
										}`,
									image: item?.receivingTempImage,
									vanTemp: item?.receivingTemp,
									id: item?.id,
									// image: 'https://placehold.co/600x400',
									// height: 400,
								});
							}}
							width={100}
							height={50}
							// src='https://placehold.co/600x400'
							src={item?.receivingTempImage}
							alt={src}
						/>
					) : (
						<>-</>
					)}
				</div>
			);
		},
		'Order Amount': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const orderAmount =
				item?.finalValue == 0 ? item?.orderValue : item?.finalValue;
			return (
				<div>
					<span className='text-gray-700'>
						₹{orderAmount >= 0 ? addCommas(orderAmount) : '-'}
					</span>
					{getPODeltas(item)}
				</div>
			);
		},
		Action: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div className='flex flex-col gap-2 w-full'>
					{item?.orderStatus === 'DISPATCH' && (
						<Button
							className='125px'
							variant='secondary'
							onClick={(e) => {
								toggleAlert(true, {
									heading: 'Re-Open PO',
									handleConfirm: () => {
										handlePoStatus(itemId, 'REOPEN');
										toggleAlert(false);
									},
									colorReverse: true,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you to re-open po-${item?.id || ''
										}?`,
								});
							}}
						>
							Re-Open
						</Button>
					)}
					{item?.orderStatus === 'PENDING' && (
						<Button
							className='125px danger-btn'
							onClick={(e) => {
								e.stopPropagation();
								toggleAlert(true, {
									heading: 'Cancel PO',
									handleConfirm: () => {
										handlePoStatus(itemId, 'CANCEL');
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you to cancel ${item?.id || ''
										}?`,
								});
							}}
						>
							Cancel PO
						</Button>
					)}
				</div>
			);
		},
	};

	const handleEditSubmit = async (editedValues) => {
		try {
			const response = await assetServices.editAssetTemp({
				data: editedValues,
				params: {
					type: 'PO',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? error?.message,
			});
		}
	};

	// Use a single global draft key for production plan
	const DRAFT_KEY = 'unsavedListData_productionPlan';

	// Helper to check if a global draft exists
	function globalDraftExists() {
		return !!localStorage.getItem(DRAFT_KEY);
	}

	const [draftExists, setDraftExists] = useState(globalDraftExists());

	// Keep draftExists in sync with localStorage changes
	useEffect(() => {
		const handler = () => setDraftExists(globalDraftExists());
		window.addEventListener('storage', handler);
		return () => window.removeEventListener('storage', handler);
	}, []);

	// When a draft is created or deleted, update state
	const updateDraftState = () => setDraftExists(globalDraftExists());

	const handleFilterDrawerOpen = () => {
		toggleFiltersDrawer(true, {
			handleDataExport: (filtersState) =>
				handleExport({
					...exportFilters.current,
					dateRangeFilter: {
						dateType: filtersState?.timeType?.value,
						from: moment(filtersState?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filtersState?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
					},
					variantIds: [
						...new Set(
							filtersState?.productWithVariant?.productData?.flatMap(
								(item) => item?.variantIds
							)
						),
					],
					exportType: filtersState?.exportType,
				}),
		});
	};

	// Replace generateProductionPlan logic
	const generateProductionPlan = async (idsList) => {
		const isDispatchSelectd =
			filters?.dateRange?.dateType == 'dispatchDate';
		if (!isDispatchSelectd) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select Expected dispatch date, and Search POs',
			});
			handleFilterDrawerOpen();
			return;
		}
		// Determine shiftId to send
		let resolvedShiftId = null;
		const selectedPOs = data?.filter((po) => idsList?.includes(po?.id));
		const shiftIds = selectedPOs?.map((po) => po?.shiftId);
		const nonNullShiftIds = shiftIds?.filter((id) => id != null);
		const uniqueNonNullShiftIds = [...new Set(nonNullShiftIds)];
		if (uniqueNonNullShiftIds.length > 1) {
			// Different shiftIds found - show error with details
			const shiftIdMap = {};
			selectedPOs.forEach((po) => {
				const shiftKey = po?.shiftId ?? 'null';
				if (!shiftIdMap[shiftKey]) shiftIdMap[shiftKey] = [];
				shiftIdMap[shiftKey].push(po?.id);
			});
			const details = Object.entries(shiftIdMap)
				.map(
					([shiftKey, ids]) =>
						`Shift: ${shiftKey} => PO IDs: [${ids.join(', ')}]`
				)
				.join('\n');
			notificationServices.generateNotification({
				type: 'error',
				message: `Cannot proceed: Selected POs have different shift IDs.\n${details}`,
			});
			return;
		}
		resolvedShiftId =
			uniqueNonNullShiftIds.length > 0 ? uniqueNonNullShiftIds[0] : null;
		if (globalDraftExists()) {
			toggleAlert(true, {
				heading: 'Draft Exists',
				message:
					'There is already a draft for the production plan. Would you like to edit the draft or create a new one? Creating new will overwrite the existing draft.',
				confirmText: 'Edit Draft',
				cancelText: 'Create New',
				showCloseBtn: false,
				colorReverse: false,
				handleConfirm: () => {
					const draftData = JSON.parse(
						localStorage.getItem(DRAFT_KEY)
					);
					toggleProductionPlanModal(true, {
						idsList: draftData?.idsList || idsList,
						storeId:
							draftData?.storeId || navSelectedStore?.value?.id,
						date: draftData?.date || filters?.dateRange?.startDate,
						listData: draftData,
						draftKey: DRAFT_KEY,
						...(resolvedShiftId != null && {
							shiftId: resolvedShiftId,
						}),
					});
					toggleAlert(false);
				},
				handleCancel: () => {
					localStorage.removeItem(DRAFT_KEY);
					updateDraftState();
					proceedGenerateProductionPlan(
						idsList,
						true,
						resolvedShiftId
					);
					toggleAlert(false);
				},
			});
			return;
		}
		proceedGenerateProductionPlan(idsList, false, resolvedShiftId);
	};

	// Helper to actually fetch and open the production plan modal
	const proceedGenerateProductionPlan = async (
		idsList,
		overwriteDraft,
		resolvedShiftId = null
	) => {
		const req = {
			data: {
				poIds: idsList,
				storeId: navSelectedStore?.value?.id,
				date: filters?.dateRange?.startDate,
			},
		};
		setProductionPlanLoading(true);
		try {
			const response =
				await inventoryAnalyticsServices.fetchProductionPlan(req);
			if (response?.statusCode === 200) {
				if (overwriteDraft) {
					try {
						localStorage.setItem(
							DRAFT_KEY,
							JSON.stringify({
								...response?.data,
								idsList,
								storeId: navSelectedStore?.value?.id,
								date: filters?.dateRange?.startDate,
							})
						);
						updateDraftState();
					} catch (e) {
						console.error('Error saving draft:', e);
					}
				}
				toggleProductionPlanModal(true, {
					idsList,
					storeId: navSelectedStore?.value?.id,
					date: filters?.dateRange?.startDate,
					listData: response?.data,
					draftKey: DRAFT_KEY,
					...(resolvedShiftId != null && {
						shiftId: resolvedShiftId,
					}),
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			console.log(error);
		} finally {
			setProductionPlanLoading(false);
		}
	};

	const moreOptionsList = {
		'E-Way bill': (po, cb) => {
			if (!orderStatus?.slice(2, -1).includes(po?.orderStatus)) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No invoice has been generated yet for this order',
				});
				return;
			}
			const urlType = 'EWAYBILL';
			const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&type=${urlType}`;
			history.push(url);
			cb();
		},
		'E-Invoice': (po, cb) => {
			if (!orderStatus?.slice(2, -1).includes(po?.orderStatus)) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No invoice has been generated yet for this order',
				});
				return;
			}
			const urlType = 'INVOICE';
			const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&type=${urlType}`;
			history.push(url);
			cb();
		},
	};

	const handleFetchPurchaseOrderList = (finderFilters, isRefresh = false) => {
		setSelectedRow([]);
		setIsRefresh(isRefresh);
		const dateRange = {
			startDate: moment(finderFilters?.dateRange?.from).format(
				'YYYY-MM-DD'
			),
			endDate: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
			dateType: finderFilters?.timeType?.value,
		};
		setFilterValue(finderFilters);
		setFilters((prev) => {
			return {
				...prev,
				dateRange,
				fulfilledBy: finderFilters?.store?.id,
			};
		});
		let idFilter = {};
		if (!isRefresh) {
			if (poId != null && poId !== '') {
				idFilter = { poId: Number(poId) };
			} else if (search?.value === 'poId' && search?.searchValue) {
				const parsed = Number(search?.searchValue);
				if (Number.isFinite(parsed)) {
					idFilter = { poId: parsed };
				}
			} else if (search?.searchValue) {
				idFilter = { clientPoId: search?.searchValue };
			}
		}
		const req = {
			data: {
				filters: {
					storeId:
						finderFilters?.store?.id === -999
							? null
							: finderFilters?.store?.id,
					fromStoreId:
						finderFilters?.deliverFrom?.id === -999
							? null
							: finderFilters?.deliverFrom?.id,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
						dateType: dateRange.dateType,
					},
					status: finderFilters?.status,
					variantIds: [
						...new Set(
							finderFilters?.productWithVariant?.productData?.flatMap(
								(item) => item?.variantIds
							)
						),
					],
					orderType: 'sales/purchase',
					userOrderType: 'sales',
					productionPlanStatus: finderFilters?.productionPlanStatus,
					...idFilter,
				},
			},
		};
		exportFilters.current = req.data.filters;
		fetchPurchaseOrderList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'PO_LIST',
			req,
		});
	};

	// eslint-disable-next-line no-unused-vars
	const combinePO = async () => {
		const from = moment(filters?.dateRange?.startDate).format('YYYY-MM-DD');
		const to = moment(filters?.dateRange?.endDate).format('YYYY-MM-DD');
		try {
			const req = {
				data: {
					storeId: navSelectedStore?.value?.id,
					dateRangeFilter: {
						from,
						to,
					},
				},
			};
			const response =
				await inventoryAnalyticsServices.combinePurchaseOrder({
					req,
				});

			// Check if the Content-Type of the response is 'text/csv'
			const contentType = response?.headers?.get('Content-Type');
			if (contentType && contentType?.includes('text/csv')) {
				const blob = await response.blob(); // Get the response data as a Blob
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = `Combined_PO_${from}-${to}.csv`;
				link.click();
				window.URL.revokeObjectURL(blobUrl);

				notificationServices.generateNotification({
					type: 'success',
					message: 'Combined and Downloaded Successfully',
				});
			} else {
				// Handle the case where the response is not 'text/csv'
				try {
					const errorData = await response.json(); // Try to parse the response as JSON
					const errorMessage = errorData?.errorMessage; // Extract the error message
					notificationServices.generateNotification({
						type: 'error',
						message: errorMessage || 'Some error occurred.',
					});
				} catch (jsonError) {
					// Handle the case where the response is not JSON or doesn't contain an error message
					notificationServices.generateNotification({
						type: 'error',
						message: 'Some error occurred.',
					});
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error occurred while combining',
			});
		}
	};

	const handleExport = async (fltersObj) => {
		try {
			setLoading(true);
			const response =
				await orderAnalyticsServices.exportGRNWiseOrderHistory({
					data: {
						filters: fltersObj,
					},
				});
			if (response.status === 200) {
				handleResponseStreamDownload(
					response,
					`INTERNAL_SALES_ORDERS_${fltersObj?.dateRangeFilter?.from}_${fltersObj?.dateRangeFilter?.to}.csv`
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setLoading(false);
		}
	};

	const handleOnUpdate = (finderFilters) => {
		const req = {
			data: {
				filters: {
					storeId: finderFilters?.store?.id,
					fromStoreId:
						navSelectedStore?.value?.id === -999
							? null
							: navSelectedStore?.value?.id,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
						dateType: finderFilters?.timeType?.value,
					},
					status: finderFilters?.status,
					orderType: 'sales/purchase',
					userOrderType: 'sales',
					productionPlanStatus: finderFilters?.productionPlanStatus,
				},
			},
		};
		exportFilters.current = req.data.filters;
	};

	const generateData = () => {
		let list = data || [];
		if (shift) {
			list = list.filter((item) => item?.shiftId == shift);
		}

		return list
			.map((item) => ({
				...item,
				rowStyles: item?.jsonData?.generatedPPId ? 'bg-green-200' : '',
			}))
			.sort((a, b) => {
				const aPP = !!a?.jsonData?.generatedPPId;
				const bPP = !!b?.jsonData?.generatedPPId;
				if (aPP === bPP) return 0;
				return aPP ? 1 : -1;
			});
	};

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		deliverFrom: {
			text: 'Deliver From',
			show: true,
		},
		store: {
			text: 'Deliver To',
			show: true,
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		status: {
			text: 'Status',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
		productionPlanStatus: {
			text: 'Production Plan Status',
			show: true,
		},
	};

	const dropDownItems = [
		{
			label: 'Client PO ID',
			value: 'clientPoId',
			placeholder: 'Search by Client PO ID',
			getData: true,
		},
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by Po ID',
			getData: true,
		},
	];

	const exportInfo = {
		showDropDown: true,
		showExportBtn: true,
		exportTypes: [
			{
				label: 'Invoice-Item wise Sales Register(Finance[ER-UR])',
				value: 'invoiceItemWiseSales',
			},
			{
				label: 'Invoice-Item wise Sales Register',
				value: 'invoiceItemWiseSales_nonFinance',
			},
			{
				label: 'Item-Wise GRN Fullfilment',
				value: 'itemWiseGrn',
			},
			{
				label: 'Item-Wise Sales Register',
				value: 'itemWiseSales',
			},
		],
	};
	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			handleFetchPurchaseOrderList(filterValue);
		}
	}, [search?.searchValue]);

	const handleStartBulkEdit = () => {
		const tomorrow = moment().add(1, 'days').toDate();
		toggleMultiplePoModal(true, {
			navSelectedStore: navSelectedStore,
			mode: 'orderWise',
			orderwise: true,
			initialState: {
				fromStore: filters?.fulfilledBy ?? null,
				expectedDeliveryDate: tomorrow,
				orderType: 'PO',
			},
		});
	};

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			handleFetchPurchaseOrderList();
		}
	};

	const tableData = generateData();
	const showSelectionItems =
		tableData?.length > 0 &&
		!tableData.every((item) => !!item?.jsonData?.generatedPPId);

	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />
			<POItemsModal />
			<DatePickerModal
				show={datePickerModalState?.show}
				heading={datePickerModalState?.heading}
				restrictDateType='before'
				currentPo={datePickerModalState?.currentPo}
				onClose={() => {
					setDatePickerModalState({ show: false, heading: '' });
				}}
				onSubmit={handleDatePickerModalSetDate}
			/>
			<AssetTransitModal />
			<ProductionPlanModal onCloseModal={updateDraftState} />
			<BackdropLoader isLoading={productionPlanLoading} showProgress />
			<VanImageModal handleEditSubmit={handleEditSubmit} />
			<DebitCreditListDrawer />
			<MultiPoModal />
			{/* <ExportFiltersDrawer
				subCategories={subCategoriesList?.map((ele) => {
					return {
						id: ele?.id,
						value: ele?.id,
						title: ele?.categoryName,
						label: ele?.categoryName,
					};
				})}
			/> */}
			<ImagesFinder
				onSubmit={handleFetchPurchaseOrderList}
				update={update}
				blink={filters?.blink}
				statusList={orderStatus?.map((ele) => {
					if (ele === 'FULFILLED') {
						return {
							id: ele,
							title: 'CLOSED',
						};
					}
					if (ele === 'TRANSIT') {
						return {
							id: ele,
							title: 'IN TRANSIT',
						};
					}
					if (ele === 'DISPATCH') {
						return {
							id: ele,
							title: 'PENDING DISPATCH',
						};
					}
					if (ele === 'UNLOADING') {
						return {
							id: ele,
							title: 'UNLOADING STARTED',
						};
					}
					if (ele === 'VERIFICATION') {
						return {
							id: ele,
							title: 'PENDING VERIFICATION',
						};
					}
					return {
						id: ele,
						title: ele,
					};
				})}
				preventDateRangeCheckbox
				onUpdate={handleOnUpdate}
				timeTypeArray={dateTypeArr}
				orderText
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between items-center w-full p-4'>
				<span className='font-bold text-[16px]'>
					{isWynBrands
						? 'Store and Buyer Sales Order'
						: 'Store Sales Order'}
				</span>
				{level !== 1 && (
					<div className='flex gap-2 items-center'>
						{(function () {
							let typeId = 1;
							if (isInternalSales) {
								if (
									navSelectedStore?.value?.type?.includes(
										'WAREHOUSE'
									)
								) {
									typeId = 3;
								} else {
									typeId = 2;
								}
							}
							const storageKey = getStorageKey(typeId);
							const draft = loadState(storageKey);

							if (draft) {
								return (
									<Button
										onClick={() => {
											let typeId = 1;
											if (isInternalSales) {
												if (
													navSelectedStore?.value?.type?.includes(
														'WAREHOUSE'
													)
												) {
													typeId = 3;
												} else {
													typeId = 2;
												}
											}
											history.push(
												`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=sales&typeId=${typeId}&fromStore=${navSelectedStore?.value?.id}&storeTypes=${navSelectedStore?.storesType}&editDraft=true`,
												{
													prevPath:
														location?.pathname +
														location?.search,
												}
											);
										}}
										className='bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105'
									>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											className='h-5 w-5'
											viewBox='0 0 20 20'
											fill='currentColor'
										>
											<path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
										</svg>
										Edit Draft
									</Button>
								);
							}
							return null;
						})()}
						<Button
							onClick={(e) => {
								let typeId = 1;
								if (isInternalSales) {
									if (
										navSelectedStore?.value?.type?.includes(
											'WAREHOUSE'
										)
									) {
										typeId = 3;
									} else {
										typeId = 2;
									}
								}
								history.push(
									`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=sales&typeId=${typeId}&fromStore=${navSelectedStore?.value?.id}&storeTypes=${navSelectedStore?.storesType}`,
									{
										prevPath:
											location?.pathname +
											location?.search,
									}
								);
							}}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Create Order
						</Button>
						<Button
							onClick={handleStartBulkEdit}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							Edit And Review Multiple Order
						</Button>

						{isWynBrands && (
							<Button
								onClick={() => {
									const baseUrl = `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=8`;
									history.push(baseUrl, {
										prevPath:
											location?.pathname +
											location?.search,
									});
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Buyer Sales Order
							</Button>
						)}
						{isA2bCustomer && (
							<Button
								onClick={() =>
									dispatch(
										modalActions.toggleMultiplePoModal(
											true,
											{
												navSelectedStore: {
													fromStore:
														navSelectedStore?.value
															?.id,
												},
											}
										)
									)
								}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Multiple Order
							</Button>
						)}
					</div>
				)}
			</div>
			<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className='w-[90%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip title='Refresh Store Sales Order'>
					<RefreshCcw
						className='size-5 cursor-pointer'
						onClick={(e) => {
							handleFetchPurchaseOrderList(filterValue, true);
						}}
					/>
				</Tooltip>
				<Button
					onClick={(e) => {
						handleFilterDrawerOpen();
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{navSelectedStore?.value?.id &&
				navSelectedStore?.value?.id !== -999 &&
				navSelectedStore?.value?.type === 'BASE' && (
					<div className='flex gap-2 w-full g ml-[16px]'>
						<Button
							type='button'
							onClick={combinePO}
							className='bg-blue-600'
						>
							COMBINE PO
						</Button>
						{shifts.length > 0 && (
							<SelectPicker
								data={shifts}
								value={shift}
								className='w-[300px]'
								placeholder='Select Shift'
								onChange={(value) => {
									setShift(value);
								}}
							/>
						)}
					</div>
				)}
			{filtersInfoChip(filtersInfo, filterValue)}
			<div className={styles?.table} style={{ width: '100%' }}>
				<ListTable
					legend={
						<div className='flex items-center gap-2'>
							<div className='w-4 h-4 bg-green-200 border border-green-400 rounded-sm' />
							<span className='text-[13px] font-semibold text-gray-700 whitespace-nowrap'>Production Plan Generated</span>
						</div>
					}
					shift={{
						list: shifts,
						shift,
					}}
					hasDateRange
					allowCheckList={
						showSelectionItems &&
						data?.length > 0 &&
						navSelectedStore?.value?.type === 'BASE' &&
						level !== 1 &&
						((appConfig?.customerId == 68 && shift) ||
							appConfig?.customerId != 68)
					}
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={tableData}
					moreOptionsList={moreOptionsList}
					actions={[
						...SPECIAL_COLUMNS.filter((item) => {
							if (isWynBrands) return true;
							return item?.title !== 'Order Type';
						}),
						...ACTION_COLUMNS,
					]}
					special={SPECIAL_ITEMS}
					setSelectedRow={setSelectedRow}
					selectedRows={selectedRow}
					handleViewClick={handleViewClick}
					generateProductionPlan={generateProductionPlan}
					viewMoreOptionsList={viewMoreOptionsList}
					allowExport={false}
					// renderColumn={renderColumn}
					// Disable selection for draft rows
					removeRowSelectionFn={(item) => !!item?.jsonData?.generatedPPId}
					disabledRowSelectionFn={() => false}
					draftExists={draftExists}
					draftOpenFn={() => {
						const draftData = JSON.parse(
							localStorage.getItem(DRAFT_KEY)
						);
						toggleProductionPlanModal(true, {
							idsList: draftData?.idsList || [],
							storeId:
								draftData?.storeId ||
								navSelectedStore?.value?.id,
							date:
								draftData?.date ||
								filters?.dateRange?.startDate,
							listData: draftData,
							draftKey: DRAFT_KEY,
							draftExists: draftExists,
						});
					}}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { PO_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const categoriesList = state.form.PRODUCT_CATEGORY.data.LIST;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { userList } = state.auth;
	const alertModalState = state.modal.alertModal;
	return {
		data,
		stores,
		navState,
		dateRangeFilter,
		categoriesList,
		subCategoriesList,
		userPermissions,
		userList,
		alertModalState,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
	fetchPurchaseOrderList: analyticsAction.gateway,
	fetchSubCategories: formActions.gateway,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	toggleDebitCreditListDrawer: drawerActions.toggleDebitCreditListDrawer,
	fetchUserList: authActions?.fetchUserList,
	toggleAssetTransit: modalActions.toggleAssetTransit,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	toggleMultiplePoModal: modalActions.toggleMultiplePoModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderList);
